import React, { createContext, useContext, useState, useEffect } from 'react';

// 1. CREATE CONTEXT - This is like creating a "global storage box"
const FooterContext = createContext();

// 2. CUSTOM HOOK - Makes it easy to use the context
export const useFooter = () => {
  const context = useContext(FooterContext);
  if (!context) {
    throw new Error('useFooter must be used within FooterProvider');
  }
  return context;
};

// 3. PROVIDER - Wraps your app and provides the state to all children
export const FooterProvider = ({ children }) => {
  // Get initial state from localStorage (remember user's preference)
  const [isExpanded, setIsExpanded] = useState(() => {
    const saved = localStorage.getItem('footerExpanded');
    return saved ? JSON.parse(saved) : false; // Default: collapsed
  });

  // Toggle function
  const toggleFooter = () => {
    setIsExpanded(prev => !prev);
  };

  // Save to localStorage whenever state changes
  useEffect(() => {
    localStorage.setItem('footerExpanded', JSON.stringify(isExpanded));
  }, [isExpanded]);

  // The "value" is what all components can access
  const value = {
    isExpanded,      // Current state: true/false
    toggleFooter,    // Function to toggle
    setIsExpanded    // Function to set directly
  };

  return (
    <FooterContext.Provider value={value}>
      {children}
    </FooterContext.Provider>
  );
};
